import { Grid } from "@mui/material";
import { t } from "i18next";

//import general components
import BaseTitle from "../../../common/base-title/base-title";

//import images and icons
import logoImage from "../../../../assets/imgs/logo1.png";
import { CloseCircle, TickCircle } from "iconsax-react";

//import styles
import "./tour-description.scss";

function TourDescription({ tourInformation }) {
    //render boolean icon
    const renderBooleanIcon = condition => (condition ? <TickCircle color="var(--primary-color)" /> : <CloseCircle color="var(--red-color)" />);

    return (
        <Grid className="tour-description" container item md={4.5} rowGap={2} order={{ xs: 2, md: 1 }}>
            <BaseTitle title={t("agency")} dividerColor="1px solid var(--medium-gray-color)" />

            <Grid container item xs={12} columnGap={2} alignItems="center">
                <Grid className="tour-description__logo-image" container alignItems="center">
                    <img src={logoImage} alt="" />
                </Grid>

                <Grid container item xs="auto" rowGap={1} direction="column">
                    <span className="tour-description__company-name">پیشگام پرتو گشت ویرا ( آتریپا )</span>
                    {/* <Grid container justifyContent="space-between" alignItems="center">
                        <span className="tour-description__rate">3.4/5</span>
                        <BaseRating value="2" icon={Record} emptyIcon={Record} color="var(--primary-color)" size="20" readOnly />
                    </Grid> */}
                </Grid>
            </Grid>

            <BaseTitle title={t("tourServices")} dividerColor="1px solid var(--medium-gray-color)" />

            <Grid container item xs={12} rowGap={1}>
                <Grid container item xs={12} columnGap={3}>
                    <span className="tour-description__tour-service">{renderBooleanIcon(tourInformation?.visa_required)} {t("visaRequired")}</span>
                    <span className="tour-description__tour-service">{renderBooleanIcon(tourInformation?.airport_transfer)} {t("airportTransfer")}</span>
                </Grid>
                <span className="tour-description__tour-service">{tourInformation?.services}</span>
            </Grid>

            <BaseTitle title={t("description")} dividerColor="1px solid var(--medium-gray-color)" />

            <Grid className="tour-description__description" component="p" container item xs={12}>
                {tourInformation?.description}
            </Grid>
        </Grid>
    );
}

export default TourDescription;
